import styled from '@emotion/styled';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';

type MessageContainerProps = {
	opened?: boolean;
};

const {
	color: colours,
	spacing: {
		size_16px: { height: size_16 },
		size_160px: { height: size_160 }
	}
} = tokens;

export const MessageContainer = styled.section<MessageContainerProps>`
	width: 100%;
	overflow: hidden;
	max-height: ${({ opened }) => (opened ? ` ${3 * size_160}px` : `0`)};
	margin: ${({ opened }) => (opened ? `0 0 ${size_16}px 0` : `0`)};
	transition:
		margin 0.4s ease-in-out,
		max-height 0.4s ease-in-out;

	ul {
		margin: 1em 0;
		padding: 0 0 0 1em;
	}

	p {
		margin: 0 0 1em 0;
	}

	li + li {
		margin-top: 0.5em;
	}

	& > *:last-child {
		margin-bottom: 0;
	}
`;
